import React from 'react';
import { FileText, Film, Layers } from 'lucide-react';
import type { ContentType } from './types';
import { contentTypeOptions } from './ReelsStoryConstants';

interface ContentTypeSelectorProps {
  selectedContentType: ContentType;
  onContentTypeSelect: (contentType: ContentType) => void;
}

const iconMap: Record<string, React.FC<{ className?: string }>> = {
  FileText,
  Film,
  Layers,
};

export const ContentTypeSelector: React.FC<ContentTypeSelectorProps> = ({
  selectedContentType,
  onContentTypeSelect,
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Typ treści
      </label>
      <div className="grid grid-cols-3 gap-2">
        {contentTypeOptions.map((option) => {
          const Icon = iconMap[option.iconName] || FileText;
          const isSelected = selectedContentType === option.id;

          return (
            <button
              key={option.id}
              type="button"
              onClick={() => onContentTypeSelect(option.id)}
              className={`
                relative flex flex-col items-center gap-1.5 px-3 py-3 rounded-xl border-2 transition-all duration-200
                ${isSelected
                  ? `${option.borderColor} ${option.bgLight} shadow-md scale-[1.02]`
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                }
              `}
            >
              <div className={`
                p-2 rounded-lg transition-colors
                ${isSelected ? option.color + ' text-white' : 'bg-gray-100 text-gray-500'}
              `}>
                <Icon className="w-5 h-5" />
              </div>
              <span className={`text-sm font-semibold ${isSelected ? option.textColor : 'text-gray-700'}`}>
                {option.label}
              </span>
              <span className="text-[10px] text-gray-500 text-center leading-tight">
                {option.description}
              </span>
              {isSelected && (
                <div className={`absolute -top-1 -right-1 w-4 h-4 rounded-full ${option.color} flex items-center justify-center`}>
                  <svg className="w-2.5 h-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
